<template>
  <footer v-if="customerBaseline && customerMediaUrl">
    <h4>{{ customerBaseline }}</h4>
    <component
      :is="component"
      class="logo"
      :to="customerWebLink || customerSponsorInfoLink"
      :target="target"
      @click="handleClick"
    >
      <img v-if="customerMediaUrl" :src="customerMediaUrl" />
    </component>
  </footer>
</template>
<script setup lang="ts">
const {
  customer: {
    customerBaseline,
    customerWebLink,
    customerMedia,
    customerSponsorInfoLink,
    customerSponsorInfo,
    customerCategory,
  },

  mPageMedias,
} = inject(INJECT_CATEGORY_PAGE);

const { categoryCustomerClicked } = useAppEventSponsorInfo();

const customerMediaUrl = computed(() => {
  const md = mPageMedias.value.get(customerMedia.value);
  if (md) {
    return md.urlCompressed || md.url;
  }
});

const target = computed(() => {
  if (toValue(customerWebLink)) return '_blank';
  return '_self';
});

const component = computed(() => {
  if (toValue(customerWebLink) || toValue(customerSponsorInfoLink)) {
    return resolveComponent('NuxtLink');
  }
  return 'div';
});

const handleClick = computed(() => {
  if (toValue(customerWebLink) || toValue(customerSponsorInfoLink)) {
    categoryCustomerClicked(
      customerCategory.value.id,
      customerWebLink.value,
      customerSponsorInfo.value
    );
  }
});
</script>
<style lang="scss" scoped>
footer {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: var(--gap_m);
  align-items: center;
  @include above('l') {
    grid-template-columns: 1fr auto;
  }
  h4 {
    @include font('s', 400, 'secondary');

    color: var(--color_neutral_700);
    font-style: italic;
    text-align: right;
  }
  .logo {
    img {
      width: 100%;
      max-width: 8rem;
      height: 100%;
      max-height: 8rem;
      object-fit: contain;
    }
  }
}
</style>
